import React from 'react';
import '../Stats.css';

const stats = [
  { label: 'Morceaux notés', value: 120, max: 200, icon: '🎵' },
  { label: 'Albums référencés', value: 45, max: 100, icon: '💿' },
  { label: 'Playlists créées', value: 7, max: 20, icon: '📀' },
  { label: 'Commentaires', value: 34, max: 100, icon: '💬' },
];

export default function Stats() {
  return (
    <div className="stats-root">
      <h1 className="stats-title">Statistiques</h1>
      <div className="stats-list">
        {stats.map((s, i) => {
          const percent = Math.round((s.value / s.max) * 100);
          return (
            <div className="stats-item" key={i}>
              <div className="stats-label">
                <span className="stats-icon">{s.icon}</span>
                {s.label}
              </div>
              <div className="stats-bar">
                <div
                  className="stats-value"
                  style={{ width: `${percent}%` }}
                >
                  <span className="stats-bar-value">{s.value}</span>
                  <span className="stats-bar-percent">{percent}%</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
} 